const ACTIONS = {
    GET_VIDEO_DATES: "getVideoDates",
}

export { ACTIONS }